import OliveImages from "@olive/images";

const Images = OliveImages;

type Image = "success" | "verifyPhoneCall" | "verifySms";

interface IImageMap {
    [image: string]: any;
}

const ImageMap: IImageMap = {
    success: Images.success,
    verifyPhoneCall: Images.verifyPhoneCall,
    verifySms: Images.verifySms
};

export function getImage(image: Image) {
    return ImageMap[image];
}

export default Images;
